let localize;

export function generateMetadataContainer(player) {
    localize = player.localize?.bind(player);
    const template = `<div>
    <div class="mediasite-player__metadata-modal-header">
        <h2 class="mediasite-player__metadata-modal-title"></h2>
        <p class="mediasite-player__date-time-duration-container">
            <small class="mediasite-player__metadata-modal-date"></small>
            <small class="mediasite-player__metadata-modal-time"></small>
            <small class="mediasite-player__metadata-modal-duration"></small>
        </p>
    </div>
    <h3>${localize('Description')}:</h3>
    <div class="mediasite-player__metadata-modal-description"></div>
    <div>
        <h3>${localize('Presenters')}:</h3>
        <ul class="mediasite-player__metadata-modal-speaker-list"></ul>
        <h3>${localize('Links')}:</h3>
        <ul class="mediasite-player__metadata-modal-links-list"></ul>
        <div class="mediasite-player__metadata-modal-compliance-policy" hidden></div>
    </div>
</div>`;

    return convertTextToElement(template);
}

export function generateSpeakerBio(name, imgUrl, bioUrl) {
    let textHTML = '<li class="mediasite-player__speaker-bio">';

    if (imgUrl) {
        textHTML += `<img alt="${name}" src="${imgUrl}">`;
    }
    else {
        textHTML += `<div id="default-presenter" alt="${name}"></div>`;
    }

    if (bioUrl) {
        textHTML += `<a href="${bioUrl}" target="_blank">${name}</a></li>`;
    } else {
        textHTML += `<span>${name}</span></li>`;
    }

    return convertTextToElement(textHTML);
}

export function generateLink(title, url) {
    return convertTextToElement(`<li><a href="${url}" target="_blank">${title}</a></li>`);
}

function convertTextToElement(html) {
    const container = document.createElement('div');
    container.innerHTML = html;
    return container.firstElementChild;
}
